import React, { useState, useEffect } from 'react';

const Support = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  // Check for mobile screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <>
      {/* Add viewport meta and CSS reset for mobile */}
      <style jsx global>{`
        html, body {
          margin: 0;
          padding: 0;
          width: 100%;
          overflow-x: hidden;
        }
        
        * {
          box-sizing: border-box;
        }
      `}</style>
      
      <div className="google-landing-override ffw-typography" style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(180deg, #eef4ff 0%, #dce8ff 46%, #edf4ff 100%)', 
        width: '100%',
        position: 'relative',
        margin: 0,
        padding: 0,
        overflowX: 'hidden'
      }}>
        {/* Header */}
        <header style={{ 
          padding: isMobile ? '12px 16px' : '16px 24px', 
          borderBottom: '1px solid #e8eaed',
          backgroundColor: '#f8fbff',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between', 
            maxWidth: '1200px', 
            margin: '0 auto',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '16px' : '0',
            width: '100%'
          }}>
            {!isMobile && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src="/assets/FFWLOGOtransparent.png" alt="Face Forward Web" style={{ 
                  height: '40px', 
                  width: 'auto', 
                  marginRight: '32px'
                }} />
              </div>
            )}
            
            <nav className="ffw-nav" style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: isMobile ? '20px' : '32px',
              flexWrap: 'wrap',
              justifyContent: isMobile ? 'center' : 'flex-end'
            }}>
              <a href="/" style={{ 
                fontSize: '14px', 
                color: '#5f6368', 
                textDecoration: 'none', 
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#202124';
                e.target.style.borderBottomColor = '#4285f4';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#5f6368';
                e.target.style.borderBottomColor = 'transparent';
              }}>Home</a>
              <a href="/team" style={{ 
                fontSize: '14px', 
                color: '#5f6368', 
                textDecoration: 'none', 
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#202124';
                e.target.style.borderBottomColor = '#4285f4';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#5f6368';
                e.target.style.borderBottomColor = 'transparent';
              }}>Team</a>
              <a href="/support" style={{ 
                fontSize: '14px', 
                color: '#202124', 
                textDecoration: 'none', 
                padding: '8px 0',
                borderBottom: '2px solid #4285f4',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}>Support</a>
              <a href="/participate-flyer" style={{ 
                fontSize: '14px', 
                color: '#5f6368', 
                textDecoration: 'none', 
                padding: '8px 0',
                borderBottom: '2px solid transparent',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#202124';
                e.target.style.borderBottomColor = '#4285f4';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#5f6368';
                e.target.style.borderBottomColor = 'transparent';
              }}>Participate/Refer</a>
              <a href="/login" style={{ 
                fontSize: '14px', 
                color: '#4285f4', 
                textDecoration: 'none', 
                padding: '8px 16px',
                border: '1px solid #4285f4',
                borderRadius: '50px',
                transition: 'all 0.2s ease',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#4285f4';
                e.target.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#4285f4';
              }}>Sign In</a>
            </nav>
          </div>
        </header>

        {/* Main Content */}
        <main style={{ 
          padding: isMobile ? '64px 16px 48px' : '92px 24px 84px', 
          textAlign: 'center',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          {/* Page Title */}
          <div style={{ marginBottom: isMobile ? '48px' : '64px' }}>
            <h1 style={{ 
              fontSize: isMobile ? '2rem' : '2.5rem', 
              fontWeight: '400', 
              color: '#202124', 
              marginBottom: isMobile ? '16px' : '24px',
              fontFamily: 'Product Sans, Arial, sans-serif',
              padding: isMobile ? '0 8px' : '0',
              margin: isMobile ? '0 0 16px 0' : '0 0 24px 0'
            }}>
              Support
            </h1>
            <p style={{ 
              fontSize: isMobile ? '14px' : '16px', 
              color: '#5f6368', 
              maxWidth: '600px', 
              margin: isMobile ? '0 auto 32px' : '0 auto 48px',
              lineHeight: '1.6',
              padding: isMobile ? '0 8px' : '0'
            }}>
              Get help with the Face Forward Web program
            </p>

            {/* Trust Logos - Mobile and Desktop */}
            {isMobile ? (
              /* Mobile: Vertical Stack */
              <div style={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '32px',
                padding: '20px',
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                margin: '0 16px 32px 16px'
              }}>
                <img 
                  src="/assets/harvardmedical_logo.png" 
                  alt="Harvard Medical School" 
                  style={{ 
                    height: '32px', 
                    width: 'auto'
                  }}
                />
                <img 
                  src="/assets/mgh_logo.png" 
                  alt="Massachusetts General Hospital" 
                  style={{ 
                    height: '32px', 
                    width: 'auto'
                  }}
                />
                <img 
                  src="/assets/CHOIRlogo.png" 
                  alt="CHOIR" 
                  style={{ 
                    height: '32px', 
                    width: 'auto'
                  }}
                />
              </div>
            ) : (
              /* Desktop: Horizontal */
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                gap: '32px',
                marginBottom: '48px',
                flexWrap: 'wrap'
              }}>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  padding: '16px 24px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '24px'
                }}>
                  <img 
                    src="/assets/harvardmedical_logo.png" 
                    alt="Harvard Medical School" 
                    style={{ 
                      height: '40px', 
                      width: 'auto'
                    }}
                  />
                  <img 
                    src="/assets/mgh_logo.png" 
                    alt="Massachusetts General Hospital" 
                    style={{ 
                      height: '40px', 
                      width: 'auto'
                    }}
                  />
                  <img 
                    src="/assets/CHOIRlogo.png" 
                    alt="CHOIR" 
                    style={{ 
                      height: '40px', 
                      width: 'auto'
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </main>

        {/* Contact Information */}
        <section style={{ 
          padding: isMobile ? '60px 16px' : '80px 24px', 
          backgroundColor: 'transparent',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ 
              textAlign: 'center', 
              marginBottom: isMobile ? '32px' : '48px'
            }}>
              <h2 style={{ 
                fontSize: isMobile ? '1.6rem' : '2rem', 
                fontWeight: '400', 
                color: '#202124', 
                marginBottom: isMobile ? '12px' : '16px',
                fontFamily: 'Product Sans, Arial, sans-serif',
                padding: isMobile ? '0 8px' : '0',
                margin: isMobile ? '0 0 12px 0' : '0 0 16px 0'
              }}>
                Contact Information
              </h2>
              <p style={{ 
                fontSize: isMobile ? '0.85rem' : '0.9rem', 
                color: '#5f6368', 
                maxWidth: '600px', 
                margin: '0 auto',
                lineHeight: '1.6',
                padding: isMobile ? '0 8px' : '0'
              }}>
                For any questions about the Face Forward Web program, please reach out to us:
              </p>
            </div>

            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))', 
              gap: isMobile ? '24px' : '32px',
              marginBottom: isMobile ? '48px' : '64px'
            }}>
              {/* Email Contact */}
              <div className="ffw-panel" style={{ 
                backgroundColor: 'rgba(248, 251, 255, 0.78)', 
                padding: isMobile ? '24px' : '32px', 
                borderRadius: '16px',
                textAlign: 'center',
                border: '1px solid rgba(124, 145, 178, 0.24)',
                backdropFilter: 'blur(2px)'
              }}>
                <div style={{ 
                  width: '48px', 
                  height: '48px', 
                  backgroundColor: '#4285f4', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  margin: '0 auto 16px'
                }}>
                  <svg width="24" height="24" fill="white" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </div>
                <h3 style={{ 
                  fontSize: isMobile ? '18px' : '20px', 
                  fontWeight: '500', 
                  color: '#202124', 
                  marginBottom: '8px',
                  margin: '0 0 8px 0'
                }}>Email</h3>
                <a href="mailto:mghfacialpainstudy@mgb.org" style={{ 
                  fontSize: isMobile ? '13px' : '14px', 
                  color: '#4285f4', 
                  textDecoration: 'none',
                  wordBreak: 'break-word',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#3367d6'}
                onMouseLeave={(e) => e.target.style.color = '#4285f4'}>
                  mghfacialpainstudy@mgb.org
                </a>
              </div>

              {/* Phone Contact */}
              <div className="ffw-panel" style={{ 
                backgroundColor: 'rgba(248, 251, 255, 0.78)', 
                padding: isMobile ? '24px' : '32px', 
                borderRadius: '16px',
                textAlign: 'center',
                border: '1px solid rgba(124, 145, 178, 0.24)',
                backdropFilter: 'blur(2px)'
              }}>
                <div style={{ 
                  width: '48px', 
                  height: '48px', 
                  backgroundColor: '#34a853', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  margin: '0 auto 16px'
                }}>
                  <svg width="24" height="24" fill="white" viewBox="0 0 24 24">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                  </svg>
                </div>
                <h3 style={{ 
                  fontSize: isMobile ? '18px' : '20px', 
                  fontWeight: '500', 
                  color: '#202124', 
                  marginBottom: '8px',
                  margin: '0 0 8px 0'
                }}>Phone</h3>
                <p style={{ 
                  fontSize: isMobile ? '13px' : '14px', 
                  color: '#5f6368',
                  margin: 0
                }}>
                  (617) 643-8678
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Emergency Disclaimer */}
        <section style={{ 
          padding: isMobile ? '44px 16px' : '72px 24px',
          backgroundColor: 'transparent',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ maxWidth: '980px', margin: '0 auto' }}>
            <div style={{ 
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              gap: isMobile ? '14px' : '20px',
              marginBottom: '0',
              backgroundColor: 'rgba(255, 248, 248, 0.78)',
              border: '1px solid rgba(234, 67, 53, 0.26)',
              borderLeft: '6px solid #EA4335',
              borderRadius: '14px',
              padding: isMobile ? '22px 18px' : '28px 30px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
              backdropFilter: 'blur(2px)'
            }}>
              <div style={{ 
                width: isMobile ? '30px' : '36px', 
                height: isMobile ? '30px' : '36px', 
                backgroundColor: '#EA4335', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                <svg width={isMobile ? '16' : '18'} height={isMobile ? '16' : '18'} fill="white" viewBox="0 0 24 24">
                  <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                </svg>
              </div>
              <div style={{ textAlign: 'left' }}>
                <h3 style={{ 
                  fontSize: isMobile ? '18px' : '24px', 
                  fontWeight: '600', 
                  color: '#EA4335', 
                  letterSpacing: '-0.01em',
                  marginBottom: isMobile ? '8px' : '10px',
                  margin: '0 0 10px 0'
                }}>Important Emergency Information</h3>
                
                <p style={{ 
                  fontSize: isMobile ? '15px' : '18px', 
                  color: '#3F3F46', 
                  lineHeight: '1.65',
                  fontWeight: '500',
                  margin: 0
                }}>
                  If you experience acute distress and feel unsafe, call 911.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer style={{ 
          borderTop: 'none', 
          padding: isMobile ? '32px 16px' : '48px 24px',
          backgroundColor: 'transparent',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: isMobile ? '24px' : '32px'
            }}>
              <div>
               </div>
            </div>
            
            <div style={{ 
              marginTop: isMobile ? '24px' : '32px', 
              paddingTop: isMobile ? '16px' : '24px', 
              borderTop: 'none', 
              textAlign: 'center'
            }}>
              <p style={{ 
                fontSize: isMobile ? '11px' : '12px', 
                color: '#5f6368',
                margin: 0
              }}>
                © 2025 Face Forward Web. Developed by Harvard Medical School and Massachusetts General Hospital.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Support;
